import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex:1;
    justify-content: center;
    align-items: center;
    align-content: center;
    height: 100%;
    flex-direction: column;
    

    form{
        display: flex;
        flex-direction: column;
        min-width: 300px;
        margin-top: 20px;
    }

    .outros{
        background: -moz-linear-gradient(top, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0) 47%);
        background: -webkit-linear-gradient(top, rgba(0,0,0,0.1) 0%,rgba(0,0,0,0) 47%);
        background: linear-gradient(to bottom, rgba(0,0,0,0.1) 0%,rgba(0,0,0,0) 47%);
        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#1a000000', endColorstr='#00000000',GradientType=0 );
        border-radius: 10px;
        margin-top: 20px;
        display: flex;
        width: 100%;
        justify-content: center;
        align-items: center;
    }
    .outros .botao {
        font-size: 10px;
        width: 46%;
        width: calc(50% - 15px);
        padding: 5px 0;
        margin: 10px 2px 8px 2px;
        font-weight: 700;
        box-shadow: 1px 1px 3px -1px rgb(0 0 0 / 25%);
        text-shadow: none;
        color: #32465B;
        background: #F6F4F0;
        border-radius: 5px;
        text-transform: uppercase;
        text-align: center;
        text-decoration: none;
        
        &:hover{
            background: var(--darkblue);
            color: #fff
        }
    }
    @media(max-width: 280px){
      form{
        min-width: 260px;
      }
    }
`

export const Aviso = styled.div`
    display: inline-block;
    padding: 3px;
    width: 260px;
    font-size: 0.7rem;
    text-align: center;
    margin-bottom: -10px;
`
